define('bizzabo/views/popup/ConfirmDialogView',[
    'jquery',
    'underscore',
    'backbone',
    'bizzabo/consts',
    'bizzabo/views/popup/PopupView',
    'hbars!bizzabo/templates/confirmDialog'
], function(
    $,
    _,
    Backbone,
    Consts,
    PopupView,
    template
    ) {

    var ConfirmDialogView = PopupView.extend({

        events : {
            'click .confirmButton' : 'confirmClicked',
            'click .cancelButton' : 'cancelClicked'
        },

        initialize : function() {
            this.popUpInitialize();
            this.model = new Backbone.Model({
                title : this.options.title ? this.options.title : 'Please confirm',
                text : this.options.text ? this.options.text : undefined,
                html : this.options.html ? this.options.html : undefined,
                frameSrc : this.options.frameSrc ? this.options.frameSrc : undefined,
                confirm : this.options.confirm ? this.options.confirm : 'YES',
                cancel : this.options.cancel ? this.options.cancel : undefined,
                isDestructive : this.options.isDestructive ? this.options.isDestructive : false,
                youtubeVideo : this.options.youtubeVideo ? this.options.youtubeVideo : false
            });
            if (this.model.get('youtubeVideo')) {
                this.model.set('html', '<iframe width="420" height="315" src="//www.youtube.com/embed/' + this.model.get('youtubeVideo') + '" frameborder="0" allowfullscreen></iframe>');
            }
        },

        renderSize : function() {
            this.$el.css('width', 'auto');
            this.$('.modal-body').css({
                overflow : 'auto',
                maxHeight : '400px'
            });
            if (this.model.has('frameSrc')) {
                this.$('.modal-body').css('width', '680px');
            }
        },

        render : function() {
            var source = this.model.toJSON();
            var html = template(source);
            this.$el.html(html);
            this.renderSize();
            return this;
        },

        viewRendered: function() {
            if (this.model.get('youtubeVideo')) {
                this.render();
            }
        },

        confirmClicked : function() {
            if (this.options.onConfirm && _.isFunction(this.options.onConfirm)) {
                this.options.onConfirm();
            }
            this.hide();
        },

        cancelClicked : function() {
            if (this.options.onCancel && _.isFunction(this.options.onCancel)) {
                this.options.onCancel();
            }
            this.hide();
            Backbone.trigger(Consts.Notifications.analytics.TRACK_EVENT, {
                category : 'Organizer Actions',
                action : 'Confirmation cancel clicked'
            });
        }
    });

    return ConfirmDialogView;

});
